// Package Imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-limit',
  templateUrl: './page-limit.component.html',
  styleUrls: ['./page-limit.component.css']
})
export class PageLimitComponent implements OnInit {
  @Input() selectedValue: number;
  @Input() options: number[];
  @Input() id = 'pageLimit';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() select = new EventEmitter();

  ngOnInit(): void {
    this.selectedValue = 10;
    this.options = [10, 25, 50];
  }

  onChange($event: any): void {
    this.selectedValue = $event;
    this.select.emit(this.selectedValue);
  }
}
